import { render, staticRenderFns } from "./KBListMenu.vue?vue&type=template&id=eafdd86a&"
import script from "./KBListMenu.vue?vue&type=script&lang=ts&"
export * from "./KBListMenu.vue?vue&type=script&lang=ts&"
import style0 from "./KBListMenu.vue?vue&type=style&index=0&id=eafdd86a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports